import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface PmContractStatusState {
  data: any[];
  isLoading: boolean;
  error: string | null;
}

const initialState: PmContractStatusState = {
  data: [],
  isLoading: false,
  error: null,
};

const PmContractStatusSlice = createSlice({
  name: 'pmContractStatus',
  initialState,
  reducers: {
    setPmContractStatuses: (state, action: PayloadAction<any[]>) => {
      state.data = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    setPmContractStatusesLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setPmContractStatusesError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
      state.isLoading = false;
    },
  },
});

export const { setPmContractStatuses, setPmContractStatusesLoading, setPmContractStatusesError } =
  PmContractStatusSlice.actions;

export default PmContractStatusSlice.reducer;
